import { sbaAxios } from "../utils/sbaAxios";
import { getPipeline } from "../../config/apiConfig";
import {
    FETCH_PIPELINE_BEGIN,
    FETCH_PIPELINE_SUCCESS,
    FETCH_PIPELINE_FAILURE
} from '../constants/pipeline';

export const getPipelineAction = (pipelinedata) => {
   
    return (dispatch) => {
        dispatch(fetchPipelineBegin());
        sbaAxios({
            url: `${getPipeline}`,
            method: 'post',
            data: { pipelinedata }
        })
            .then((repos) => {
                const Pipelinedata = repos;
                dispatch(fetchPipelineSuccess(Pipelinedata));
                return Pipelinedata;
            })
            .catch((error) => dispatch(fetchPipelineFailure(error)));
    };
}

export const fetchPipelineBegin = () => ({
    type: FETCH_PIPELINE_BEGIN,
});

export const fetchPipelineSuccess = (Pipelinedata) => ({
    type: FETCH_PIPELINE_SUCCESS,
    payload: { Pipelinedata },
});


export const fetchPipelineFailure = (errorMessage) => ({
    type: FETCH_PIPELINE_FAILURE,
    payload: { errorMessage }
});
